import { connect } from 'react-redux'
import { setErrorMessage } from 'actions/account'
import { setCamperFormField, setCamperForm } from 'actions/account/campers'

const mapStateToProps = ({ campers: { form } }) => ({ form })

const actions = { setCamperFormField, setCamperForm, setErrorMessage }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
